<script lang="ts">
  import UserInfo from "../../blocks/UserInfo.svelte";
  import Logo from "./Logo.svelte";
  import { settings, t } from "../../../core";
  import type { IContact } from "../../blocks/UserInfo.svelte";

  interface ICustomFooter {
    contactPerson?: IContact;
    contactData: string;
    openingHours: string;
  }

  let footerData: ICustomFooter = settings?.footer;
</script>

{#if footerData}
  <footer>
    <div class="content g-centered">
      <Logo />

      <div class="footer-content">
        <div class="address column">
          <div class="column-title">{t("Footer.Lind.Title")}</div>
          <div class="column-text rte">
            {@html footerData.contactData}
          </div>
        </div>
        <div class="time column">
          <div class="column-title">{t("Footer.OpeningHours.Title")}</div>
          <div class="column-text rte">
            {@html footerData.openingHours}
          </div>
        </div>
        <div class="contact column">
          {#if footerData.contactPerson}
            <div class="column-title">
              {t("Footer.ContactConsultant.Title")}
            </div>
            <UserInfo data={footerData.contactPerson} isLightMode={true} />
          {/if}
        </div>
      </div>
    </div>
  </footer>
{/if}

<style lang="scss">
  footer {
    background: $key-color;

    @media print {
      display: none;
    }
  }

  .content {
    color: $text-reverse-color;
    padding-top: 40px;
    padding-bottom: 10px;

    @include sm {
      padding-bottom: 60px;
    }
  }

  .footer-content {
    display: flex;
    flex-wrap: wrap;
  }

  .column {
    flex: 1 0 100%;
    margin-bottom: 40px;
    font-size: 13px;
    line-height: 1.85;

    &:not(:last-child) {
      padding-right: 30px;
    }

    @include md {
      font-size: 16px;
      line-height: 1.6;
      margin-bottom: 20px;
      flex: 1;
    }
  }

  .column-title {
    font-weight: 700;
    text-transform: uppercase;
  }

  .column-text {
    :global(a) {
      color: $text-reverse-color;
    }
    :global(p) {
      margin-bottom: 0;
    }
  }

  .time {
    .column-text {
      font-weight: 700;
    }
  }

  .contact {
    .column-title {
      margin-bottom: 10px;
    }
  }
</style>
